export const SUPPLIES_DISPLAY_LOCATION = {
  HOME: 'home',
  SETTINGS: 'settings',
  SETTINGS_PACKAGES: 'settings-packages',
  SETTINGS_PRINTING_CONNECT: 'settings-printing-connect',
  SETTINGS_PRINTING_SETUP: 'settings-printing-setup',
  SUPPLIES_PAGE: 'supplies-page',
} as const;

export type SuppliesDisplayLocation = (typeof SUPPLIES_DISPLAY_LOCATION)[keyof typeof SUPPLIES_DISPLAY_LOCATION];

export const SHIPSTATION_SUPPLIES_URL = 'https://supplies.shipstation.com/';

export const SUPPLIES_ANALYTICS_CATEGORIES = {
  HARDWARE: 'hardware',
  LABELS: 'labels',
  PACKAGING: 'packaging',
} as const;

export const UTM_PARAMS_MAP: Record<string, URLSearchParams> = {
  HOME: new URLSearchParams({
    utm_source: 'shipstation+client',
    utm_medium: 'homepage',
    utm_campaign: 'supplies+cards',
  }),
  SETTINGS: new URLSearchParams({
    utm_source: 'shipstation+client',
    utm_medium: 'settings',
    utm_campaign: 'supplies+cards',
  }),
  SETTINGS_PRINTING_SETUP: new URLSearchParams({
    utm_source: 'shipstation+client',
    utm_medium: 'printing+setup',
    utm_campaign: 'supplies+cards',
  }),
  SETTINGS_PRINTING_CONNECT: new URLSearchParams({
    utm_source: 'shipstation+client',
    utm_medium: 'printing+connect',
    utm_campaign: 'supplies+cards',
  }),
  SETTINGS_PACKAGES: new URLSearchParams({
    utm_source: 'shipstation+client',
    utm_medium: 'packages+settings',
    utm_campaign: 'supplies+cards',
  }),
};
